import React,{useContext} from 'react'
import Navbar from '../navbar/navbar';
import { AuthContext } from '../authmanager/authcontext';
import { CartContext } from '../cart/cart';
const ThankYou = ({toggleTheme}) => {
    const { handleLogout } = useContext(AuthContext);
    const {
        finalizeCart,
      } = useContext(CartContext);
  return (
    <div>
    <Navbar toggleTheme={toggleTheme} handleLogout={handleLogout} finalizeCart={finalizeCart} />
    <section id="thank-you" style={styles.section}>
      <h2 style={styles.heading}>Thank You!</h2>
      <p style={styles.message}>Thank you for your feedback. We appreciate your effort to help us improve our products and services.</p>
    </section>
    </div>
  );
};

const styles = {
  section: {
    padding: '20px',
    backgroundColor: '#f4f4f4',
    borderRadius: '8px',
    margin: '20px 0',
    textAlign: 'center'
  },
  heading: {
    fontSize: '24px',
    marginBottom: '20px',
    color: '#333'
  },
  message: {
    fontSize: '16px',
    color: '#333'
  }
};

export default ThankYou;
